import { useIsAuthenticated } from "@azure/msal-react";
import { Icons } from "@repo/ui";
import { type FC, useEffect } from "react";
import { PortalAppBar } from "../../components/AppBar/Bars";
import Attention from "../../components/AttentionBlock";
import { BottomNavigationDesktopComponent } from "../../components/BottomNavigation";
import ErrorContent from "../../components/ErrorPage/ErrorContent";
import { useLayout } from "../../components/Layout/context";
import InternalButtonLink from "../../components/Link/InternalButtonLink";
import { Seo } from "../../components/SEO";

export const AppBar: FC = () => <PortalAppBar BottomNavigationComponent={BottomNavigationDesktopComponent} />;

const NotFoundPageContent: FC = () => {
    const isAuthorized = useIsAuthenticated();
    return (
        <ErrorContent>
            <Attention severity="error" title="Stránka nenalezena">
                Ajaj! Možná jste se překlikli nebo stránka neexistuje. Pokud chcete kouknout na Portál, klikněte na Chci
                na Portál.
            </Attention>
            <InternalButtonLink
                to={isAuthorized ? "/smlouvy" : "/prihlaseni-nebo-registrace"}
                variant="contained"
                endIcon={<Icons.CaretRight />}
            >
                Chci na Portál
            </InternalButtonLink>
        </ErrorContent>
    );
};

const NotFoundPage: FC = () => {
    const isAuthorized = useIsAuthenticated();
    const { setBottomNavigation } = useLayout();

    useEffect(() => {
        if (isAuthorized) setBottomNavigation("shown");
        return () => {
            setBottomNavigation("unset");
        };
    }, [isAuthorized, setBottomNavigation]);

    return <NotFoundPageContent />;
};

export default NotFoundPage;

export const Head: FC = () => (
    <Seo title="Stránka nenalezena">
        <meta name="robots" content="noindex" />
    </Seo>
);
